import styles from './ProductSupplierRenderer.module.scss';

type TypeSupplier = { supplierCode: string; supplierName: string };

/** 공급사 목록을 `첫 공급사 외 N건` 으로 보인다. */
const ProductSupplierRenderer = ({ value }: { value?: TypeSupplier[] | null }) => {
  if (!value || value.length === 0) {
    return <div className={styles['suppliers-cell-renderer']}>{'-'}</div>;
  }

  return (
    <div className={styles['suppliers-cell-renderer']}>
      <span className={styles['supplier-name']}>{value[0].supplierName ? value[0].supplierName : '-'}</span>
      {value.length > 1 && <span className={styles['supplier-count']}>&nbsp;{`외 ${value.length - 1}건`}</span>}
    </div>
  );
};

export default ProductSupplierRenderer;
